// このファイルは scripts/renewal/gen_site.py でモックアップから生成した。
// 文言・構成を直すときは、このファイルを直接編集してよい（再生成はしない）。
import { Link } from "react-router-dom";
import ContactBand from "../../ContactBand";

export default function CaseEhon() {
  return (
    <main>
      <section className="page-hero ground cd-hero" data-en="WORKS">
        <div className="container">
          <nav className="breadcrumb">
            <Link to="/">トップ</Link>
            <Link to="/cases">実績・事例</Link>
            <span>ÉHON TIME CAPSULE</span>
          </nav>
          <div className="case-tags cd-tags">
            <span>出版</span>
            <span>ブロックチェーン事業開発</span>
          </div>
          <h1 className="cd-title">
            20年後に開封される、絵本のデジタルタイムカプセル「ÉHON TIME
            CAPSULE」
          </h1>
          <p className="cd-client">絵本出版社</p>
          <div className="cd-img is-cover">
            <span className="cover-en">DIGITAL TIME CAPSULE</span>
            <span className="cover-ja">絵本 × NFT</span>
          </div>
          <div className="cd-summary">
            <div>
              <span>課題</span>
              <p>
                親から子へ、未来へのメッセージを、消えない形で残せる絵本をつくりたい。
              </p>
            </div>
            <div>
              <span>解決策</span>
              <p>
                開封の時期を制限できるNFTと、ノーコードで発行できる管理サイトを開発。
              </p>
            </div>
            <div>
              <span>成果</span>
              <p>
                20年後に開封されるデジタルタイムカプセルを、ウォレット不要で提供。
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="section">
        <div className="cd-body container">
          <section className="cd-sec">
            <h2>プロジェクト概要</h2>
            <p>
              「親から子へ、未来の自分へ」をテーマに、20年後に開封されるデジタルタイムカプセルの機能を持つ絵本のサービスです。動画や音声、メッセージを改ざんできず消えない「未来へのメッセージ」として残すため、NFTとブロックチェーンを活用しました。
            </p>
          </section>
          <section className="cd-sec">
            <h2>お客様の課題</h2>
            <ul className="cd-list">
              <li>
                未来へのメッセージを、改ざんされず、消えない形で長く残したかった
              </li>
              <li>開封できる時期を、20年後などに設定できる必要があった</li>
              <li>
                暗号資産やNFTを持ったことがない利用者にも、負担なく使ってほしかった
              </li>
            </ul>
          </section>
          <section className="cd-sec">
            <h2>LEAPSの対応</h2>
            <div className="cd-point">
              <span className="cd-num">01</span>
              <div>
                <p className="cd-cat">スマートコントラクト</p>
                <h3 className="cd-ptitle">開封の時期を制限できるNFT</h3>
                <p>
                  既存のツールでは時間制限が設定できないため、発行から開封までの期間を設定できる独自のスマートコントラクト（ERC-721）を開発しました。
                </p>
              </div>
            </div>
            <div className="cd-point">
              <span className="cd-num">02</span>
              <div>
                <p className="cd-cat">ストレージ</p>
                <h3 className="cd-ptitle">大きなファイルを分散型で保管</h3>
                <p>
                  動画や音声などの大きなファイルを、分散型ストレージ（IPFS）に保管する仕組みを整えました。
                </p>
              </div>
            </div>
            <div className="cd-point">
              <span className="cd-num">03</span>
              <div>
                <p className="cd-cat">管理サイト</p>
                <h3 className="cd-ptitle">ノーコードでNFTを発行</h3>
                <p>
                  ファイルをアップロードするだけでNFTを発行・管理できるサイトを構築しました。利用者はウォレットを持たなくてもメッセージを受け取れます。
                </p>
              </div>
            </div>
          </section>
          <section className="cd-sec">
            <h2>成果</h2>
            <p>
              必要な機能に絞った開発で、スピードと費用を抑えながら、20年後に開封されるデジタルタイムカプセルを実現しました。
            </p>
          </section>
        </div>
      </section>
      <section className="section ground">
        <div className="container">
          <h2 className="home-h2">
            <img src="/assets/icn_logo.svg" alt="" className="heading-icon" />
            ほかの事例<strong>Other Works</strong>
          </h2>
          <div className="case-grid">
            <Link className="case-card" to="/cases/anybound">
              <div className="case-img">
                <img
                  src="https://stg.leaps-inc.com/cms-admin/wp-content/uploads/2026/03/FV-1024x610.png"
                  alt=""
                />
              </div>
              <p className="case-meta">株式会社JTB</p>
              <h3>
                希少な旅行体験をブロックチェーンで流通させる共創プロジェクト「anyBOUND」
              </h3>
              <div className="case-tags">
                <span>エンタープライズ</span>
                <span>ブロックチェーン事業開発</span>
                <span>共創プロジェクト</span>
              </div>
            </Link>
            <Link className="case-card" to="/cases/kanda-curry">
              <div className="case-img is-cover">
                <span className="cover-en">NFT STAMP RALLY</span>
                <span className="cover-ja">スタンプラリー × NFT</span>
              </div>
              <p className="case-meta">広告代理店</p>
              <h3>
                スタンプラリーの思い出をNFTで残す「神田カレーグランプリ2025」
              </h3>
              <div className="case-tags">
                <span>イベント・観光</span>
                <span>ブロックチェーン事業開発</span>
              </div>
            </Link>
            <Link className="case-card" to="/cases/premience">
              <div className="case-img">
                <img src="/assets/images/case-premience.jpg" alt="" />
              </div>
              <p className="case-meta">株式会社JTB</p>
              <h3>
                JTBのラグジュアリー体験ブランド「プレミエンス」のロゴ制作とサイトリニューアル
              </h3>
              <div className="case-tags">
                <span>旅行・観光</span>
                <span>ブランディング・Web制作</span>
              </div>
            </Link>
          </div>
          <div className="more">
            <Link to="/cases">実績一覧を見る →</Link>
          </div>
        </div>
      </section>
      <ContactBand ground={false} />
    </main>
  );
}
